import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { useLang } from "../contexts/LangContext";
import api, { formatApiErrorDetail } from "../lib/api";
import Logo from "../components/Logo";
import { Check } from "lucide-react";

export default function ResetPassword() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-20 pb-12" data-testid="reset-page">
      <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="reset-form">
        <Logo size="md" />
        <h1 className="font-serif text-4xl text-navy">{t.auth.resetTitle}</h1>
        <div className="divider-gold" />
        <p className="text-slate-600 text-sm">{t.auth.resetSub}</p>

        <div>
          <label className="text-xs uppercase tracking-widest text-slate-500 block mb-2">{t.auth.newPassword}</label>
          <input type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)}
            className="w-full border-b border-slate-300 focus:border-navy outline-none py-3 bg-transparent" data-testid="reset-password" />
        </div>

        {err && <div className="text-sm text-red-600" data-testid="reset-error">{err}</div>}
        {done && (
          <div className="flex items-center gap-2 text-sm text-green-700 bg-green-50 border border-green-200 px-4 py-3" data-testid="reset-success">
            <Check className="w-4 h-4" /> {t.auth.resetSuccess}
          </div>
        )}

        <button type="submit" disabled={loading || !token} className="w-full bg-navy text-white py-4 text-xs uppercase tracking-[0.25em] hover:bg-club-red transition-colors disabled:opacity-60" data-testid="reset-submit">
          {loading ? "..." : t.auth.resetSubmit}
        </button>

        {!token && <div className="text-xs text-red-600">Missing token</div>}

        <div className="text-sm text-center pt-2">
          <Link to="/login" className="text-slate-500 hover:text-club-red">← {t.nav.login}</Link>
        </div>
      </form>
    </div>
  );
}
